
//import React, { useState} from 'react';
//import Banner from '../Banner/Banner';
import {Link} from 'react-router-dom';
import Image1 from '../../../assets/Activities/Agroturismo.png';
import Image2 from '../../../assets/Activities/Productos.jpg';
import Image3 from '../../../assets/Activities/Coworking3.png';
import style from './Activitiesen.module.css';

const Activitiesen = () => {
  let currentCards = [];
  

  const images = [Image1, Image2, Image3];
  const title = ["Agrotourism",
                  "Products", 
                  "Workshops"];
  const href = ["/activities", "/product", ""]
  
  for (let i=0; i< 3; i++) {
      currentCards.push({id:i, image:images[i], title:title[i], href:href[i]})
  }
   
return (
    <div className={style.actividad}>
      <p className={style.title}>Come visit us</p>
      <div className={style.tarjetas}>
        {currentCards.map((p) => (
          <div key={p.id}>
            <Link to={p.href}>
          
            
              <div className={style.card}>
                <img className={style.imagen}src={p.image} alt="" />
                <div className={style.descripcion}>
                    <h2 className={style.name}>{p.title}</h2>
                    
                </div>
              </div>
            </Link>
            
          </div>
        ))}
      </div>
    </div>
  );
};

export default Activitiesen;